<script>
import Icon from '@/components/ui/Icon.vue'

export default {
  name: 'PasswordInput',
  components: { Icon },
  props: {
    modelValue: String,
    invalid: { type: Boolean, default: false },
    showHint: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    autocomplete: {
      type: String
    }
  },
  data() {
    return {
      passVisible: false,
      inputType: 'password'
    }
  },
  methods: {
    toggleVisibility() {
      if (this.inputType === 'text') {
        this.inputType = 'password'
      } else {
        this.inputType = 'text'
      }
    }
  }
}
</script>

<template>
  <section>
    <input
      name="password"
      class="grey-field"
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
      :type="inputType"
      :placeholder="placeholder"
      :autocomplete="autocomplete"
      :class="{ 'login-invalid': invalid, invalid: invalid }"
    />

    <button type="button" @click="toggleVisibility" class="toggle" tabindex="-1">
      <icon v-if="inputType === 'text'" name="eye-visible"></icon>
      <icon v-else name="eye-hidden"></icon>
    </button>
    <span v-if="showHint" class="hint"
      >Minimaal 12 karakters waarvan 1 hoofdletter en 1 cijfer</span
    >
  </section>
</template>

<style scoped lang="scss">
section {
  position: relative;
}

.toggle {
  position: absolute;
  right: 12px;
  top: 10px;
  cursor: pointer;
}

input {
  padding-right: 33px;
  width: 100%;
  margin-bottom: 20px;
}

.hint {
  font-size: 10px;
  padding-left: 8px;
}
</style>
